import { type } from '@/utils/type'

/*
//////////////////////////////////////////////////////////////////
// {{NAME}}
/////////////////////////////////////////////////////////////////
export const ADM_{{NAME}}_SUCCESS =  type('ADM_{{NAME}}_SUCCESS')
export const ADM_{{NAME}}_ERROR =  type('ADM_{{NAME}}_ERROR')

export const ADM_{{NAME}}_DETAIL_SUCCESS =  type('ADM_{{NAME}}_DETAIL_SUCCESS')
export const ADM_{{NAME}}_DETAIL_ERROR =  type('ADM_{{NAME}}_DETAIL_ERROR')

export const ADM_{{NAME}}_SAVE_SUCCESS =  type('ADM_{{NAME}}_SAVE_SUCCESS')
export const ADM_{{NAME}}_SAVE_ERROR =  type('ADM_{{NAME}}_SAVE_ERROR')
*/

//////////////////////////////////////////////////////////////////
// PARTENAIRE
/////////////////////////////////////////////////////////////////
export const ADM_PARTENAIRE_SUCCESS =  type('ADM_PARTENAIRE_SUCCESS')
export const ADM_PARTENAIRE_ERROR =  type('ADM_PARTENAIRE_ERROR')

export const ADM_PARTENAIRE_DETAIL_SUCCESS =  type('ADM_PARTENAIRE_DETAIL_SUCCESS')
export const ADM_PARTENAIRE_DETAIL_ERROR =  type('ADM_PARTENAIRE_DETAIL_ERROR')

export const ADM_PARTENAIRE_SAVE_SUCCESS =  type('ADM_PARTENAIRE_SAVE_SUCCESS')
export const ADM_PARTENAIRE_SAVE_ERROR =  type('ADM_PARTENAIRE_SAVE_ERROR')

export const ADM_PARTENAIRE_DELETE_SUCCESS =  type('ADM_PARTENAIRE_DELETE_SUCCESS')
export const ADM_PARTENAIRE_DELETE_ERROR =  type('ADM_PARTENAIRE_DELETE_ERROR')


//////////////////////////////////////////////////////////////////
// FLUX
/////////////////////////////////////////////////////////////////
export const ADM_FLUX_SUCCESS =  type('ADM_FLUX_SUCCESS')
export const ADM_FLUX_ERROR =  type('ADM_FLUX_ERROR')

export const ADM_FLUX_DETAIL_SUCCESS =  type('ADM_FLUX_DETAIL_SUCCESS')
export const ADM_FLUX_DETAIL_ERROR =  type('ADM_FLUX_DETAIL_ERROR')

export const ADM_FLUX_SAVE_SUCCESS =  type('ADM_FLUX_SAVE_SUCCESS')
export const ADM_FLUX_SAVE_ERROR =  type('ADM_FLUX_SAVE_ERROR')

export const ADM_FLUX_DELETE_SUCCESS =  type('ADM_FLUX_DELETE_SUCCESS')
export const ADM_FLUX_DELETE_ERROR =  type('ADM_FLUX_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// DATASOURCE
/////////////////////////////////////////////////////////////////
export const ADM_DATASOURCE_SUCCESS =  type('ADM_DATASOURCE_SUCCESS')
export const ADM_DATASOURCE_ERROR =  type('ADM_DATASOURCE_ERROR')

export const ADM_DATASOURCE_DETAIL_SUCCESS =  type('ADM_DATASOURCE_DETAIL_SUCCESS')
export const ADM_DATASOURCE_DETAIL_ERROR =  type('ADM_DATASOURCE_DETAIL_ERROR')

export const ADM_DATASOURCE_SAVE_SUCCESS =  type('ADM_DATASOURCE_SAVE_SUCCESS')
export const ADM_DATASOURCE_SAVE_ERROR =  type('ADM_DATASOURCE_SAVE_ERROR')

export const ADM_DATASOURCE_DELETE_SUCCESS =  type('ADM_DATASOURCE_DELETE_SUCCESS')
export const ADM_DATASOURCE_DELETE_ERROR =  type('ADM_DATASOURCE_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// FEEDDOWNLOAD
/////////////////////////////////////////////////////////////////
export const ADM_FEEDDOWNLOAD_SUCCESS =  type('ADM_FEEDDOWNLOAD_SUCCESS')
export const ADM_FEEDDOWNLOAD_ERROR =  type('ADM_FEEDDOWNLOAD_ERROR')

export const ADM_FEEDDOWNLOAD_DETAIL_SUCCESS =  type('ADM_FEEDDOWNLOAD_DETAIL_SUCCESS')
export const ADM_FEEDDOWNLOAD_DETAIL_ERROR =  type('ADM_FEEDDOWNLOAD_DETAIL_ERROR')

export const ADM_FEEDDOWNLOAD_SAVE_SUCCESS =  type('ADM_FEEDDOWNLOAD_SAVE_SUCCESS')
export const ADM_FEEDDOWNLOAD_SAVE_ERROR =  type('ADM_FEEDDOWNLOAD_SAVE_ERROR')

export const ADM_FEEDDOWNLOAD_DELETE_SUCCESS =  type('ADM_FEEDDOWNLOAD_DELETE_SUCCESS')
export const ADM_FEEDDOWNLOAD_DELETE_ERROR =  type('ADM_FEEDDOWNLOAD_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// PERSONNE
/////////////////////////////////////////////////////////////////
export const ADM_PERSONNE_SUCCESS =  type('ADM_PERSONNE_SUCCESS')
export const ADM_PERSONNE_ERROR =  type('ADM_PERSONNE_ERROR')

export const ADM_PERSONNE_DETAIL_SUCCESS =  type('ADM_PERSONNE_DETAIL_SUCCESS')
export const ADM_PERSONNE_DETAIL_ERROR =  type('ADM_PERSONNE_DETAIL_ERROR')

export const ADM_PERSONNE_SAVE_SUCCESS =  type('ADM_PERSONNE_SAVE_SUCCESS')
export const ADM_PERSONNE_SAVE_ERROR =  type('ADM_PERSONNE_SAVE_ERROR')

export const ADM_PERSONNE_DELETE_SUCCESS =  type('ADM_PERSONNE_DELETE_SUCCESS')
export const ADM_PERSONNE_DELETE_ERROR =  type('ADM_PERSONNE_DELETE_ERROR')


//////////////////////////////////////////////////////////////////
// PROFIL_EXCLUSION
/////////////////////////////////////////////////////////////////
export const ADM_PROFIL_EXCLUSION_SUCCESS =  type('ADM_PROFIL_EXCLUSION_SUCCESS')
export const ADM_PROFIL_EXCLUSION_ERROR =  type('ADM_PROFIL_EXCLUSION_ERROR')

export const ADM_PROFIL_EXCLUSION_DETAIL_SUCCESS =  type('ADM_PROFIL_EXCLUSION_DETAIL_SUCCESS')
export const ADM_PROFIL_EXCLUSION_DETAIL_ERROR =  type('ADM_PROFIL_EXCLUSION_DETAIL_ERROR')

export const ADM_PROFIL_EXCLUSION_SAVE_SUCCESS =  type('ADM_PROFIL_EXCLUSION_SAVE_SUCCESS')
export const ADM_PROFIL_EXCLUSION_SAVE_ERROR =  type('ADM_PROFIL_EXCLUSION_SAVE_ERROR')

export const ADM_PROFIL_EXCLUSION_DELETE_SUCCESS =  type('ADM_PROFIL_EXCLUSION_DELETE_SUCCESS')
export const ADM_PROFIL_EXCLUSION_DELETE_ERROR =  type('ADM_PROFIL_EXCLUSION_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// GROUP_CARAC
/////////////////////////////////////////////////////////////////
export const ADM_GROUP_CARAC_SUCCESS =  type('ADM_GROUP_CARAC_SUCCESS')
export const ADM_GROUP_CARAC_ERROR =  type('ADM_GROUP_CARAC_ERROR')

export const ADM_GROUP_CARAC_DETAIL_SUCCESS =  type('ADM_GROUP_CARAC_DETAIL_SUCCESS')
export const ADM_GROUP_CARAC_DETAIL_ERROR =  type('ADM_GROUP_CARAC_DETAIL_ERROR')

export const ADM_GROUP_CARAC_SAVE_SUCCESS =  type('ADM_GROUP_CARAC_SAVE_SUCCESS')
export const ADM_GROUP_CARAC_SAVE_ERROR =  type('ADM_GROUP_CARAC_SAVE_ERROR')

export const ADM_GROUP_CARAC_DELETE_SUCCESS =  type('ADM_GROUP_CARAC_DELETE_SUCCESS')
export const ADM_GROUP_CARAC_DELETE_ERROR =  type('ADM_GROUP_CARAC_DELETE_ERROR')

export const ADM_CARAC_SUCCESS =  type('ADM_CARAC_SUCCESS')
export const ADM_CARAC_ERROR =  type('ADM_CARAC_ERROR')